<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h1 class="mb-4 menu-dark font-weight-light">Whoops! What happened?</h1>

        <p class="menu-dark font-weight-normal">Please follow the link below to continue.</p>

        <a class="btn btn-outline-dark btn-lg mb-5 px-3" :href="url">{{ text }}</a>

      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'AuthLinkRefresh',
  data() {
    return  {
      loading: true,
      url: null,
      text: null
    }
  },
  methods: {
    loadData () {
      let token = this.$route.query.jwt;

      if (token) {

        axios.get('/chipin/account/auth/link/refresh/?jwt=' + token)
            .then(res => {
              res.status
              this.text = res.data.text
              this.url = res.data.url
            })
            .catch(error => {
              this.name = 'Sorry something went wrong!';
              console.log(error)
            });

      } else {
        this.name = 'Sorry something went wrong!';
      }

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
